"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDashboardWidget = exports.StyledAttributeDistributionWidget = exports.StyledAttributeBreakdownWidget = exports.StyledAttributeBreakdownWidgetsWrapper = exports.StyledProductStatusWidget = exports.StyledCategorySelectWrapper = exports.StyledSelectorsWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const attribute_distribution_1 = require("./attribute-distribution");
const dashboard_widget_1 = __importDefault(require("./dashboard-widget"));
exports.StyledSelectorsWrapper = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};    
  grid-area: selectors;

  & > div {
    width: 50%;

    ul {
      background-color: ${ui_components_1.baseColors.white};
    }
  }
`;
exports.StyledCategorySelectWrapper = styled_components_1.default.div `
  grid-area: category-select-widget;
`;
exports.StyledProductStatusWidget = (0, styled_components_1.default)(dashboard_widget_1.default) `
  grid-area: product-status-widget;
`;
exports.StyledAttributeBreakdownWidgetsWrapper = styled_components_1.default.div `
  grid-area: attribute-breakdown-widgets;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;
exports.StyledAttributeBreakdownWidget = (0, styled_components_1.default)(dashboard_widget_1.default) `
  flex: 0 0 170px;
`;
exports.StyledAttributeDistributionWidget = (0, styled_components_1.default)(attribute_distribution_1.AttributeDistributionWidget) `
  grid-area: attribute-distribution-widget;
  // widget height on the left side
  max-height: 45rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .widget-content {
    // height of content - height of heading - gap
    flex: 1 1 auto;
    max-height: calc(100% - 30px - 1rem);
  }
`;
exports.StyledDashboardWidget = styled_components_1.default.div `
  grid-area: ${({ gridArea }) => gridArea};
  height: auto;

  .widget-content {
    display: flex;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing(1)};
  }
`;
